import { Box, BoxProps, Image } from "@chakra-ui/react";
import DocIcon from "./doc-icon.svg";

export function DocxIcon({ ...props }: BoxProps) {
  return (
    <Box {...props}>
      <Image src={DocIcon} />
    </Box>
  );
}
